import "./Contact.css";

import * as React from "react";
import { Form, Text, Textarea } from "react-form";

interface IContactProps {}

interface IContactState {
    contactStatus: "init" | "failure" | "success";
}

interface IApiContactResponse {
    success: boolean;
}

export default class Contact extends React.Component<IContactProps, IContactState> {

    public constructor(props: IContactProps) {
        super(props);

        this.state = {
            contactStatus: "init"
        };
    }

    public render() {

        const { contactStatus } = this.state;

        const contactForm = (
            <Form
                onSubmit={(values) => {
                    const request = new XMLHttpRequest();

                    this.setState({
                        contactStatus: "init"
                    });

                    const baseUrl = this.isDev ? "http://herzweg/" : "/";

                    request.open("POST", `${baseUrl}api/contact.php`, true);
                    // TODO: application/x-www-form-urlencoded??
                    request.setRequestHeader("Content-Type", "text/plain");

                    request.onload = () => {
                        const response: IApiContactResponse = JSON.parse(request.responseText);
                        this.setState({
                            contactStatus: response.success ? "success" : "failure"
                        });
                    };

                    request.send(JSON.stringify(values));
                }}
                validate={({ name, email, message }) => {
                    return {
                        name: !name ? "Bitte gib Deinen Namen an" : undefined,
                        email: !email
                            ? "Bitte gib Deine E-Mail-Adresse an"
                            : (
                                !this.validateEmail(email)
                                    ? "Bitte gib eine gültige E-Mail-Adresse an"
                                    : undefined
                            ),
                        message: !message ? "Bitte gib Deine Nachricht an" : undefined
                    };
                }}
            >
                {({submitForm}) => {
                    return (
                        <form onSubmit={submitForm}>
                            <div className="Contact__formElement">
                                <label>
                                    <div className="label">Name</div>
                                    <Text id="name" field="name"/>
                                </label>
                            </div>
                            <div className="Contact__formElement">
                                <label>
                                    <div className="label">E-Mail-Adresse</div>
                                    <Text id="email" field="email"/>
                                </label>
                            </div>
                            <div className="Contact__formElement">
                                <label>
                                    <div className="label">Betreff</div>
                                    <Text id="subject" field="subject"/>
                                </label>
                            </div>
                            <div className="Contact__formElement">
                                <label>
                                    <div className="label">Nachricht</div>
                                    <Textarea id="message" field="message"/>
                                </label>
                            </div>
                            <div className="Contact__formElement">
                                <button type="submit">Senden</button>
                            </div>
                            {contactStatus === "failure" && (
                                <div className="Contact__formElement">
                                    <div className="FormError">
                                        Leider ist ein Fehler beim Senden Deiner Nachricht aufgetreten.<br/>
                                        Versuche es bitte erneut.
                                    </div>
                                </div>
                            )}
                        </form>
                    );
                }}
            </Form>
        );

        const eMailConfirmation = (
            <div className="Contact__confirmation">
                Vielen Dank für Deine Nachricht!
            </div>
        );

        const herzwegEMailAddress = "kontakt@herzweg-musik.de";

        const anchorTag = (
            <a href={`mailto:${herzwegEMailAddress}`} target="_blank">{herzwegEMailAddress}</a>
        );

        return (
            <div className="Contact">
                <div className="Contact__title"><span>KON</span>TAKT</div>
                <div className="Contact__teaser">
                    Sende uns eine Nachricht an {anchorTag} oder<br/>
                    nutze dieses Kontaktformular.
                </div>
                {contactStatus === "success"
                    ? eMailConfirmation
                    : contactForm
                }
            </div>
        );
    }

    private validateEmail(email: string) {
        const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; // tslint:disable-line:max-line-length
        return re.test(email);
    }

    private get isDev() {
        return !!window.location.href.match(/localhost/);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Contact.tsx